export function isObject (v) {
  return v !== null && typeof v === 'object' && Array.isArray(v) !== true
}

export function isDate (v) {
  return Object.prototype.toString.call(v) === '[object Date]'
}

export function isRegexp (v) {
  return Object.prototype.toString.call(v) === '[object RegExp]'
}

export function isNumber (v) {
  return typeof v === 'number' && isFinite(v)
}

function encode (value) {
  if (isDate(value) === true) {
    return 'hm__date|' + value.toUTCString()
  }
  if (isRegexp(value) === true) {
    return 'hm__expr|' + value.source
  }
  if (typeof value === 'number') {
    return 'hm__numb|' + value
  }
  if (typeof value === 'boolean') {
    return 'hm__bool|' + (value ? '1' : '0')
  }
  if (typeof value === 'string') {
    return 'hm__strn|' + value
  }
  if (typeof value === 'function') {
    return 'hm__strn|' + value.toString()
  }
  if (value === Object(value)) {
    return 'hm__objt|' + JSON.stringify(value)
  }

  // hmm, we don't know what to do with it,
  // so just return it as is
  return value
}

function decode (value) {
  const length = value.length
  if (length < 9) {
    // then it wasn't encoded by us
    return value
  }

  const type = value.substr(0, 8)
  const source = value.substring(9)

  switch (type) {
    case 'hm__date':
      return new Date(source)

    case 'hm__expr':
      return new RegExp(source)

    case 'hm__numb':
      return Number(source)

    case 'hm__bool':
      return Boolean(source === '1')

    case 'hm__strn':
      return '' + source

    case 'hm__objt':
      return JSON.parse(source)

    default:
      // hmm, we reached here, we don't know the type,
      // then it means it wasn't encoded by us, so just
      // return whatever value it is
      return value
  }
}

export default class hmStorage {
  static getLocalItem(key, def = null) {
    const item = localStorage.getItem(key)
    return item
      ? decode(item)
      : def
  }

  static hasLocal(key) {
    return localStorage.getItem(key) !== null
  }

  static setLocalItem(key, value) {
    localStorage.setItem(key, encode(value))
  }

  static clearLocal() {
    localStorage.clear()
  }

  static remove(key) {
    localStorage.removeItem(key)
  }
}
